module.exports = __webpack_public_path__ + "img/CPXQ28.fe97e702.jpg";